/**
 * Page Extras & Interactive Components Script
 * (Is file ko Assets folder mein add karein)
 */

// Global Symbol and Message Mapping for Diagrams
var SYM = {
  puffiness: { hot: ["eye-area", "cheek-area"] },
  cellulite: { hot: ["thigh-area", "glute-area"] },
  bloating: { hot: ["stomach-area"] },
  ankles: { hot: ["ankle-left", "ankle-right"] },
  rings: { hot: ["hand-left", "hand-right"] },
  lovehandles: { hot: ["waist-area"] },
  heaviness: { hot: ["legs-lower", "legs-upper"] },
  energy: { hot: ["body-core"] },
  fog: { hot: ["head-area"] },
  exhaustion: { hot: ["body-main"] },
  neck: { hot: ["jaw-area"] }
};

var SCAN1 = {
  puffiness: "Fluid is pooling around your facial tissue overnight.",
  cellulite: "Subcutaneous fluid is pushing against your skin structure.",
  bloating: "Abdominal fluid retention is occurring prior to digestion.",
  ankles: "Gravity is pulling un-drained fluid down into your lower extremities.",
  rings: "Interstitial fluid is accumulating in your fingers and hands.",
  lovehandles: "Stubborn fluid pockets are mimicking fat around the flank area.",
  heaviness: "Excess fluid weight is creating a systemic feeling of density.",
  energy: "Cellular stagnation from poor drainage is draining your vitality.",
  fog: "Slow lymphatic flow is affecting your overall mental clarity.",
  exhaustion: "Your body is working overtime overnight instead of draining and recovering.",
  neck: "Lymph fluid is pooling beneath the jawline, altering your profile."
};

/**
 * 1. Body Diagram Highlighting Function
 * Quiz ke baad body parts ko visually highlight karne ke liye
 */
function lightKeys() {
  var sec = document.querySelector('.bx.bxdark');
  // Agar quiz chal raha hai toh qyes use hoga, warna default 'puffiness'
  var ks = (typeof qyes !== 'undefined' && qyes.length) ? qyes : ['puffiness'];
  
  // Pehle attribute check karke match hone wale element ko select karein
  var sel = '.sb[onclick*="' + "'" + ks[0] + "'" + '"]';
  var btn = document.querySelector(sel);
  
  if (btn && typeof symsel === 'function') {
    symsel(ks[0], btn);
  }
  
  // Baki saare related body points par 'on' class add karein
  ks.slice(1).forEach(function(k) {
    if (SYM[k] && SYM[k].hot) {
      SYM[k].hot.forEach(function(id) {
        var n = document.getElementById(id);
        if (n) n.classList.add('on');
      });
    }
  });
  
  // Page ko smooth scroll karke diagram section par le jayein
  if (sec) {
    sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/**
 * 2. Offer/Pricing Scroll Function
 * User ko seedha prices ya offers wale section par le jaane ke liye
 */
function goOffer() {
  var t = document.getElementById('offer-tiers');
  if (t) {
    t.scrollIntoView({ behavior: 'smooth' });
  }
}

/**
 * 3. Accordion Toggle Function
 * FAQ ya drop-down contents ko kholne aur band karne ke liye
 */
function accx(el) {
  // Pehle se khule hue baki saare accordions ko band karein (Accordion Behavior)
  document.querySelectorAll('.acc.open').forEach(function(o) {
    if (o !== el) {
      o.classList.remove('open');
    }
  });
  
  // Jispar click hua usko toggle (open/close) karein
  el.classList.toggle('open');
}